// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/remove_vision_member.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/remove_vision_member.proto.
 */
export const file_vision_membership_v1_remove_vision_member: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vbWVtYmVyc2hpcC92MS9yZW1vdmVfdmlzaW9uX21lbWJlci5wcm90bxIbcHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxIpwBChlSZW1vdmVWaXNpb25NZW1iZXJSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5SZW1vdmVWaXNpb25NZW1iZXJSZXF1ZXN0LlBhcmFtcxowCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRISCgphY2NvdW50X2lkGAIgASgJInYKGlJlbW92ZVZpc2lvbk1lbWJlclJlc3BvbnNlEk4KBnJlc3VsdBgBIAEoCzI+LnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5SZW1vdmVWaXNpb25NZW1iZXJSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.membership.v1.RemoveVisionMemberRequest
 */
export type RemoveVisionMemberRequest = Message<"protos.vision.membership.v1.RemoveVisionMemberRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.RemoveVisionMemberRequest.Params params = 1;
   */
  params?: RemoveVisionMemberRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.RemoveVisionMemberRequest.
 * Use `create(RemoveVisionMemberRequestSchema)` to create a new message.
 */
export const RemoveVisionMemberRequestSchema: GenMessage<RemoveVisionMemberRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_remove_vision_member, 0);

/**
 * @generated from message protos.vision.membership.v1.RemoveVisionMemberRequest.Params
 */
export type RemoveVisionMemberRequest_Params = Message<"protos.vision.membership.v1.RemoveVisionMemberRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;
};

/**
 * Describes the message protos.vision.membership.v1.RemoveVisionMemberRequest.Params.
 * Use `create(RemoveVisionMemberRequest_ParamsSchema)` to create a new message.
 */
export const RemoveVisionMemberRequest_ParamsSchema: GenMessage<RemoveVisionMemberRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_remove_vision_member, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.RemoveVisionMemberResponse
 */
export type RemoveVisionMemberResponse = Message<"protos.vision.membership.v1.RemoveVisionMemberResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.RemoveVisionMemberResponse.Result result = 1;
   */
  result?: RemoveVisionMemberResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.RemoveVisionMemberResponse.
 * Use `create(RemoveVisionMemberResponseSchema)` to create a new message.
 */
export const RemoveVisionMemberResponseSchema: GenMessage<RemoveVisionMemberResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_remove_vision_member, 1);

/**
 * @generated from message protos.vision.membership.v1.RemoveVisionMemberResponse.Result
 */
export type RemoveVisionMemberResponse_Result = Message<"protos.vision.membership.v1.RemoveVisionMemberResponse.Result"> & {
};

/**
 * Describes the message protos.vision.membership.v1.RemoveVisionMemberResponse.Result.
 * Use `create(RemoveVisionMemberResponse_ResultSchema)` to create a new message.
 */
export const RemoveVisionMemberResponse_ResultSchema: GenMessage<RemoveVisionMemberResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_remove_vision_member, 1, 0);

